export default {
  STATUS_DRAFT: "DRAFT",
  STATUS_SAVED: "SAVED",
  STATUS_SENT: "SEND"
};
